import { CardContent } from '@/components/Card'
import { Button } from '@/components/Button'

export interface JobExtensionConfirmedProgressionActionsProps {
  onExtensionAccepted: () => unknown
  onExtensionRejected: () => unknown
}

export function JobExtensionConfirmedProgressionActions({
  onExtensionAccepted,
  onExtensionRejected,
}: JobExtensionConfirmedProgressionActionsProps) {
  return (
    <>
      <CardContent compactBottomPadding>
        <Button
          label="Extension Accepted"
          variant="primary"
          size="wide-slim"
          onPress={onExtensionAccepted}
          testId="job-progression-set-extension-approved-button"
        />
      </CardContent>

      <CardContent>
        <Button
          label="Extension Rejected"
          variant="destructive"
          size="wide-slim"
          onPress={onExtensionRejected}
          testId="job-progression-set-extension-rejected-button"
        />
      </CardContent>
    </>
  )
}
